import Vue from 'vue'
import Router from 'vue-router'

/* Layout */
import Layout from '../views/layout/layout'
import myHome from '../views/my/my_home'
import appLayout from '../views/layout/appLayout'

Vue.use(Router)

export const constantRoutes = [{
    path: '/',
    name: 'auto',
    redirect: '/web/home',
    // component: () => import('@/views/home/home')
  },
  {
    path: '/web/document',
    name: 'document',
    component: () => import('@/views/document')
  },
  {
    path: '/web/home/image/:certificate_type',
    name: 'certificate',
    component: () => import('@/views/home/certificate_detail')
  },
  // ***********************首页 strat**************
  {
    path: '/web/home',
    component: Layout,
    redirect: '/web/index',
    name: 'home',
    meta: {
      title: '',
    },
    children: [{
        path: '/web/index',
        name: 'index',
        component: () => import('@/views/home/home'),
        meta: {
          keepAlive: true
        }
      },
      {
        path: '/web/home/image_text',
        name: 'imageText',
        component: () => import('@/views/home/image_text')
      },
      {
        path: '/web/home/home_more_infor',
        name: 'homeMoreInfor',
        component: () => import('@/views/home/home_more_infor')
      },

      {
        path: '/web/home/image_text_detail',
        name: 'imageTextDetail',
        component: () => import('@/views/home/image_text_detail')
      },
      {
        path: '/web/home/home_search_result',
        name: 'homeSearchResult',
        component: () => import('@/views/home/home_search_result')
      },
      {
        path: '/web/home/register/register_signup',
        name: 'register_signup',
        component: () => import('@/views/register_distinction/register_signup')
      },
      {
        path: '/web/home/register/sign_up_from',
        name: 'sign_up_from',
        component: () => import('@/views/register_distinction/sign_up_from')
      },
      {
        path: '/web/home/register/register_detail',
        name: 'register_detail',
        component: () => import('@/views/register_distinction/register_detail')
      },
    ]
  },
  // ***********************首页 end**************

  // *****************************登录注册相关 start************************************
  {
    path: '/web/home',
    component: Layout,
    redirect: '/web/home/login',
    name: 'login',
    // meta: {
    //   title: '登录注册',
    // },
    children: [{
        path: 'register',
        name: 'register',
        component: () => import('@/views/login/register')
      }, {
        path: 'login',
        name: 'loginPop',
        component: () => import('@/views/login/login')
      }, {
        path: 'third_login',
        name: 'thirdLogin',
        component: () => import('@/views/login/third_login')
      },
      {
        path: 'bind_account',
        name: 'bindAccount',
        component: () => import('@/views/login/bind_account')
      },
      {
        path: 'set_password',
        name: 'setPassword',
        component: () => import('@/views/login/set_password')
      },
      {
        path: 'find_password',
        name: 'findPassword',
        component: () => import('@/views/login/find_password')
      }
    ]
  },
  // *****************************登录注册相关 end************************************

  // *****************************课程相关 start************************************
  {
    path: '/web/course',
    component: Layout,
    redirect: '/web/course/course_home',
    name: 'course',
    meta: {
      title: '',
    },

    children: [{
        path: '/web/course/course_home',
        name: 'courseHome',
        component: () => import('@/views/course/course_home'),
        meta: {
          keepAlive: true
        }
      },

      {
        path: '/web/course/course_detail',
        name: 'courseDetail',
        component: () => import('@/views/course/course_detail')
      },
      {
        path: '/web/course/group_chat',
        name: 'courseGroupChat',
        component: () => import('@/views/course/group_chat')
      },
      {
        path: '/web/course/course_search_result',
        name: 'courseSearchResult',
        component: () => import('@/views/course/course_search')
      },
    ]
  },

  // *****************************课程相关 end************************************

  // *****************************名家相关 start************************************
  {
    path: '/web/logicians',
    component: Layout,
    redirect: '/web/logicians',
    name: 'logicians',
    meta: {
      title: '',
    },
    children: [{
        path: '/web/logicians/masters_home',
        name: 'mastersHome',
        component: () => import('@/views/logicians/masters_home'),
        meta: {
          keepAlive: true
        }
      },
      {
        path: '/web/logicians/masters_detail',
        name: 'mastersDetail',
        component: () => import('@/views/logicians/masters_detail')
      },
      {
        path: '/web/logicians/masters_search_result',
        name: 'mastersSearchResult',
        component: () => import('@/views/logicians/masters_search')
      },
    ]
  },

  // *****************************名家相关 end************************************

  // ***************************** 商城相关 start************************************
  {
    path: '/web/store',
    component: Layout,
    redirect: '/web/store',
    name: 'store',
    meta: {
      title: '',
    },
    children: [{
        path: '/web/store/store_home',
        name: 'storeHome',
        component: () => import('@/views/store/store_home'),
        meta: {
          keepAlive: true // 需要被缓存
        }
      },
      {
        path: '/web/store/store_detail',
        name: 'storeDetail',
        component: () => import('@/views/store/store_detail')
      },
      {
        path: '/web/store/store_search_result',
        name: 'storeSearchResult',
        component: () => import('@/views/store/store_search')
      },
    ]
  },

  // *****************************商城相关 end************************************

  // *****************************我的 start************************************
  {
    path: '/web/my',
    name: 'myHomes',
    component: Layout,
    redirect: '/web/my/personal',
    meta: {
      title: '我的'
    },
    children: [{
        path: 'personal',
        name: 'myPersonal',
        // redirect: '/web/my/personal/message_center',
        meta: {
          title: '个人中心'
        },
        component: myHome,
        children: [{
            path: 'message_center',
            name: 'messageCenter',
            meta: {
              title: '消息中心'
            },
            component: () => import('@/views/my/personal/message_center'),
          },
          {
            path: '/web/my/personal/message_center/message_detail',
            name: 'messageDetail',
            meta: {
              title: '消息中心 > 消息详情'
            },
            component: () => import('@/views/my/personal/message_detail'),
          },
          {
            path: '/web/my/personal/personal_data',
            name: 'personalData',
            meta: {
              title: '个人资料'
            },
            component: () => import('@/views/my/personal/personal_data')
          },
          {
            path: '/web/my/personal/my_collect',
            name: 'myCollect',
            meta: {
              title: '我的收藏'
            },
            component: () => import('@/views/my/personal/my_collect')
          },
          {
            path: '/web/my/personal/my_course',
            name: 'myCourse',
            meta: {
              title: '我的课程'
            },
            component: () => import('@/views/my/personal/my_course')
          },
          {
            path: '/web/my/personal/my_wallet',
            name: 'myWallet',
            meta: {
              title: '我的钱包'
            },
            component: () => import('@/views/my/personal/my_wallet')
          },
          {
            path: '/web/my/personal/distinction_information',
            name: 'distinction',
            meta: {
              title: '考级报名'
            },
            component: () => import('@/views/my/personal/distinction_information')
          },
          {
            path: '/web/my/personal/distinction_detail',
            name: 'distinction_detail',
            meta: {
              title: '考级报名'
            },
            component: () => import('@/views/my/personal/distinction_detail')
          }, {
            path: '/web/my/personal/exam_signup_list',
            name: 'distinction',
            meta: {
              title: '考级报名'
            },
            component: () => import('@/views/my/personal/exam_signup_list')
          }, {
            path: '/web/my/personal/sign_up_detail',
            name: 'distinction_detail',
            meta: {
              title: '考级报名'
            },
            component: () => import('@/views/my/personal/signup_detail')
          }
        ]
      },
      {
        path: '/web/my/store',
        name: 'myStore',
        redirect: '/web/my/store/order_list',
        component: myHome,
        meta: {
          title: '商城'
        },
        children: [{
            path: 'order_list',
            name: 'myOrder',
            meta: {
              title: '订单'
            },
            component: () => import('@/views/my/store/order_list'),
          },
          {
            path: 'order_detail',
            name: 'orderDetail',
            meta: {
              title: '订单详情'
            },
            component: () => import('@/views/my/store/order_detail'),
          },
          {
            path: '/web/my/store/batch_apply_aftersales',
            name: 'batchApplyAfterSales',
            meta: {
              title: '批量申请售后'
            },
            component: () => import('@/views/my/store/batch_apply_after_sales'),
          },

          {
            path: '/web/my/store/refund_aftersale/apply',
            name: 'afterSaleDetail',
            meta: {
              title: '售后申请'
            },
            component: () => import('@/views/my/store/apply_after_sales'),
          },
          {
            path: '/web/my/store/order_list/order_evaluate',
            name: 'orderEvaluate',
            meta: {
              title: '评价订单'
            },
            component: () => import('@/views/my/store/order_evaluate'),
          },
          {
            path: '/web/my/store/order_list/order_evaluate_detail',
            name: 'orderEvaluateDetail',
            meta: {
              title: '评价详情'
            },
            component: () => import('@/views/my/store/order_evaluate_detail'),
          },
          {
            path: '/web/my/store/shopping_cart',
            name: 'shoppingCart',
            meta: {
              title: '购物车'
            },
            component: () => import('@/views/my/store/shopping_cart')
          },
          {
            path: '/web/my/store/confirm_order',
            name: 'confirmOrder',
            meta: {
              title: '确认订单'
            },
            component: () => import('@/views/my/store/confirm_order')
          },
          {
            path: '/web/my/store/my_invoice',
            name: 'myInvoice',
            meta: {
              title: '我的发票'
            },
            component: () => import('@/views/my/store/my_invoice')
          },
          {
            path: '/web/my/store/my_evaluate',
            name: 'myEvaluate',
            meta: {
              title: '我的评价'
            },
            component: () => import('@/views/my/store/my_evaluate')
          },
          {
            path: '/web/my/store/address_administration',
            name: 'myAddressAdministration',
            meta: {
              title: '地址管理'
            },
            component: () => import('@/views/my/store/address_administration')
          },
          {
            path: '/web/my/store/refund_aftersale',
            name: 'myRefundAftersale',
            meta: {
              title: '退款/售后'
            },
            component: () => import('@/views/my/store/refund_aftersale_list'),
            // children:[{
            //   path: '/web/my/store/refund_aftersale/refund_aftersale_detail',
            //   name: 'afterSaleDetail',
            //   meta: {
            //     title: '售后详情'
            //   },
            //   component: () => import('@/views/my/store/refund_aftersale_detail'),
            // }]
          },
          {
            path: '/web/my/store/refund_aftersale/refund_aftersale_detail',
            name: 'afterSaleDetail',
            meta: {
              title: '售后详情'
            },
            component: () => import('@/views/my/store/refund_aftersale_detail'),
          },
        ]
      },
      {
        path: '/web/my/system',
        name: 'mySystem',
        redirect: '/web/my/system/setting',
        component: myHome,
        meta: {
          title: '系统'
        },
        children: [{
            path: '/web/my/system/setting',
            name: 'mySetting',
            meta: {
              title: '设置'
            },
            component: () => import('@/views/my/system/setting')
          },
          {
            path: '/web/my/system/common_issue',
            name: 'myCommonIssue',
            meta: {
              title: '常见问题'
            },
            component: () => import('@/views/my/system/common_issue')
          },
          {
            path: '/web/my/system/common_issue/detail',
            name: 'myCommonIssueDetail',
            meta: {
              title: '常见问题详情'
            },
            component: () => import('@/views/my/system/common_issue_detail')
          },
          {
            path: '/web/my/system/feedback',
            name: 'feedback',
            meta: {
              title: '意见反馈'
            },
            component: () => import('@/views/my/system/feedback')
          },
          {
            path: '/web/my/system/about_us',
            name: 'aboutUs',
            meta: {
              title: '关于我们'
            },
            component: () => import('@/views/my/system/about_us')
          },
          {
            path: '/web/my/system/third_account_bind',
            name: 'thirdAccountBind',
            meta: {
              title: '第三方账号绑定'
            },
            component: () => import('@/views/my/system/third_account_bind')
          }
        ]
      }
    ]
  },

  {
    path: '/web/app',
    name: 'appShare',
    component: appLayout,
    redirect: '/web/app/share',
    meta: {

      title: '分享'
    },
    children: [{
        path: '/web/app/share',
        name: 'appShareContent',
        component: () => import('@/views/app_share/app')
      },
      {
        path: '/web/app/share/information',
        name: 'appShareInformation',
        component: () => import('@/views/app_share/information')
      },
      {
        path: '/web/app/share/course',
        name: 'appShareCourse',
        component: () => import('@/views/app_share/course')
      },
      {
        path: '/web/app/share/goods',
        name: 'appShareGoods',
        component: () => import('@/views/app_share/goods')
      },

    ]


  },
  // *****************************我的 end************************************
]

const createRouter = () => new Router({
  mode: 'history', // require service support
  scrollBehavior: () => ({
    y: 0
  }),

  routes: constantRoutes
})

const router = createRouter()

export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

export default router



// WEBPACK FOOTER //
// ./src/router/index.js